import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

// Password field with a button that toggles between hidden and visible text.
// `canReveal={false}` drops the toggle (used for the current password, which must never be shown).
const PasswordInput = ({ id, name, value, onChange, autoComplete, required, canReveal = true }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="password-wrap">
      <input
        id={id}
        name={name}
        type={visible ? "text" : "password"}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
        required={required}
      />
      {canReveal && (
      <button
        type="button"
        className="password-toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Թաքցնել գաղտնաբառը" : "Ցույց տալ գաղտնաբառը"}
        aria-pressed={visible}
      >
        <FontAwesomeIcon icon={visible ? faEyeSlash : faEye} />
      </button>
      )}
    </div>
  );
};

export default PasswordInput;
